export enum RopeDirection {
  Vertical = 1,
  Horizontal = 2,
  Cross = 3,
}
